<template>
  <section class="page-container">
    
    <div class="filters">
      <div :class="{'active': filter === 'all'}" class="all"><p @click="selectFilter('all')">Todos</p></div>
      <div :class="{'active': filter === 'onde_dormir'}" class="onde_dormir"><p @click="selectFilter('onde_dormir')">Onde Dormir</p></div>
      <div :class="{'active': filter === 'o_que_visitar'}" class="o_que_visitar"><p @click="selectFilter('o_que_visitar')">O que Visitar</p></div>
      <div :class="{'active': filter === 'onde_comer'}" class="onde_comer"><p @click="selectFilter('onde_comer')">Onde Comer</p></div>
      <div :class="{'active': filter === 'onde_comprar'}" class="onde_comprar"><p @click="selectFilter('onde_comprar')">Onde Comprar</p></div>
      <router-link to="/admin/interestPoint/new"><elvas-button :button="{title: 'Adicionar Novo'}"></elvas-button></router-link>
    </div>

    <div class="interest-points" v-if="interestPoints">
      <interestPoint :interestPoint="interestPoint" :url="'/admin/interestPoint/' + interestPoint.id" v-for="interestPoint in interestPoints" :key="interestPoint.id"/>
    </div>
  </section>
</template>
<script>

export default {
  name: 'adminInterestPoints',
  components: {
  },
  data() {
    return {
      interestPointsFull: null,
      interestPoints: null,
      filter: 'all'
    }
  },
  async mounted () {
    this.interestPoints = await this.api.get('interestPoint')
    this.interestPointsFull = [...this.interestPoints]
  },
  methods: {
    selectFilter(filter) {
      this.filter = filter
      if (filter === 'all') this.interestPoints = this.interestPointsFull
      else {
        this.interestPoints = this.interestPointsFull.filter(point => point.type === filter)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  background: #f6ede0;
}
h4 {
  font-size: 34px;
  text-transform: uppercase;
  font-weight: bold;
  margin: 20px;
  color:#f6b92f;
}
.interest-points {
  display: flex;
  flex-wrap: wrap;
  padding: 0 100px;

  @media (max-width: 1200px){
    padding: 0 80px;
  }

  @media (max-width: 900px){
    padding: 0 50px;
  }

  @media (max-width: 650px){
    padding: 0 30px;
  }

  @media (max-width: 450px){
    padding: 0 8px;
  }
}
.interest-points a {
  width: calc(100% / 4 - 40px);
  margin: 0 20px;

  @media (max-width: 1200px){
    width: calc(100% / 3 - 40px);
  }

  @media (max-width: 900px){
    width: calc(100% / 2 - 40px);
  }

  @media (max-width: 650px){
    width: calc(100% - 40px);
  }
}
.interest-points /deep/ .interest-point-item {
    margin-bottom: 40px;
    position: relative;
    & > .image {
      max-height: 200px;
      width: 100%;
      img {
        width: 100%;
      }
    }
    h2 {
      font-weight: bold;
      font-size: 18px;
      line-height: 1.22;
      letter-spacing: -0.4px;
      color: #a79374;
      margin-top: 16px;
    }
    p {
      font-size: 16px;
      line-height: 1.5;
      color: #a79374;
    }
}
.filters {
  display: flex;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  align-items: center;
  z-index: 4;
  position: relative;
  margin-bottom: 32px;
  padding-left: 100px;
  padding-right: 120px;
  div:not(.elvas-button) {
    height: 74px;
    display: flex;
    align-items: center;
    opacity: 0.5;
    border-bottom: 2px solid transparent;
    &.active {
      opacity: 1;
    }
    &.all {
       color: #f6b92f;
       &.active {
        opacity: 1;
      }
    }
    &.onde_comer {
      p {
        color: #0d3677;
      }
    }
    &.onde_dormir {
      p {
       color: #b32a2e;
      }
    }
    &.o_que_visitar {
      p {
        color: #67641e;
      }
    }
    &.onde_comprar {
      p {
        color: #6c30a9;
      }
    }
  }
  & > a {
    margin-left: auto;
  }
  p {
    color: #f6b92f;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.67;
    letter-spacing: -0.4px;
    padding: 0 20px;
    cursor: pointer;
  }

  @media (max-width: 900px){
    padding-left: 50px;
    padding-right: 70px;

    p {
      font-size: 14px;
    }

    .elvas-button {
      padding: 8px 28px;
    }
  }



  @media (max-width: 750px){
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding-top: 8px;
    padding-bottom: 8px;
    gap: 8px;
    padding: 8px 16px;

    div:not(.elvas-button) {
      height: 28px;
    }

    p {
      line-height: 1;
    }

  }
}

</style>